<app-embedded-toolbar (onConfigure)="scope.openConfiguration()" [configurationName]="scope.translations.HOME_CONFIG"></app-embedded-toolbar>
<ng-container *ngIf="scope.config.enableHomePage; else showNoAccessMsg">
<div class="data-hero">
    <div class="data-hero__spotlight" aria-hidden="true" [class.data-hero__spotlight--theme]="scope.config.useThemeGlow">
        <img *ngIf="!scope.config.useThemeGlow" src="https://prmarketing-assets.s3.us-east-1.amazonaws.com/spotlight.png" alt="" width="580">
    </div>
    <div class="data-hero__image">
        <div appImgEditContainer="home"
            [path]="scope.uploadImageIcon.section2"
            name="Hero Image"
            class="data-hero__img-container"
            [class.data-hero__img-container--sized]="scope.config.heroImageMaxWidth"
            [style.max-width]="scope.config.heroImageMaxWidth || null">
            <img [src]="scope.component.assets?.section2"
                [alt]="scope.getText | transform:'HERO_HEADING'">
        </div>
        <div class="data-hero__hero-text"
            appTextEditContainer="home"
            name="Hero Text"
            [title]="'HERO_HEADING'"
            [body]="'HERO_SUBHEADING'">
            <div class="data-hero__heading">
                {{scope.getText | transform:'HERO_HEADING'}}
            </div>
            <p class="data-hero__subheading">
                {{scope.getText | transform:'HERO_SUBHEADING'}}
            </p>
        </div>
    </div>
</div>

<div class="job-search" disabledDiv *ngIf="!scope.config.disableJobSearchPage">
    <form class="job-search__form" (submit)="scope.search()">
        <div class="job-search__field">
            <label class="job-search__label" for="jobText">{{scope.getText | transform:'FIND_JOBS'}}</label>
            <mat-form-field appearance="outline" class="job-search__input">
                <input matInput id="jobText" name="jobText"
                    [placeholder]="scope.getText | transform:'FIND_JOBS_PLACEHOLDER'"
                    [formControl]="scope.jobText">
            </mat-form-field>
        </div>
        <div class="job-search__divider"></div>
        <div class="job-search__field">
            <label class="job-search__label" for="locSearch">{{scope.getText | transform:'NEAR_LOCATION'}}</label>
            <mat-form-field appearance="outline" class="job-search__input">
                <input matInput id="locSearch" name="locSearch"
                    [placeholder]="scope.getText | transform:'NEAR_LOCATION_PLACEHOLDER'"
                    [matAutocomplete]="auto" [formControl]="scope.selectedLocation">
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="scope.createLocationString" (optionSelected)="scope.search()">
                <mat-option *ngFor="let location of scope.locations" [value]="location">
                    {{scope.createLocationString | transform:location}}
                </mat-option>
            </mat-autocomplete>
        </div>
        <button class="job-search__submit" type="submit">{{scope.getText | transform:'SEARCH'}}</button>
    </form>
</div>

<div class="about" *ngIf="scope.config.enableAboutSections">
    <div class="about__section">
        <div class="about__img-container" appImgEditContainer="home"
            name="About Image"
            [path]="scope.uploadImageIcon.section1">
            <img class="about__img" [src]="scope.component.assets?.section1"
                [alt]="scope.getText | transform:'SECTION1_TITLE'">
        </div>
        <div class="about__text" appTextEditContainer="home"
            name="About"
            [title]="'SECTION1_TITLE'" [body]="'SECTION1_BODY'">
            <h2 class="about__heading">{{scope.getText | transform:'SECTION1_TITLE'}}</h2>
            <div class="about__body" [innerHTML]="scope.component.textMap.SECTION1_BODY"></div>
        </div>
    </div>
    <div class="about__section about__section--reverse">
        <div class="about__img-container" appImgEditContainer="home"
            name="About (Continued) Image"
            [path]="scope.uploadImageIcon.image">
            <img class="about__img" [src]="scope.component.assets?.image"
                [alt]="scope.getText | transform:'SECTION2_TITLE'">
        </div>
        <div class="about__text" appTextEditContainer="home"
            name="About (continued)"
            [title]="'SECTION2_TITLE'" [body]="'SECTION2_BODY'">
            <h2 class="about__heading">{{scope.getText | transform:'SECTION2_TITLE'}}</h2>
            <div class="about__body" [innerHTML]="scope.component.textMap.SECTION2_BODY"></div>
        </div>
    </div>
</div>

<div class="talent-cta"
    *ngIf="scope.config.enableTalentCta !== false"
    appTextEditContainer="home"
    name="Talent CTA"
    [title]="'TALENT_CTA_HEADING'"
    [body]="'TALENT_CTA_BODY'">
    <h2 class="talent-cta__heading">{{scope.getText | transform:'TALENT_CTA_HEADING'}}</h2>
    <p class="talent-cta__body">{{scope.getText | transform:'TALENT_CTA_BODY'}}</p>
    <a routerLink="/register" class="talent-cta__button">
        {{scope.getText | transform:'JOIN_TALENT_COMMUNITY_BUTTON'}} <mat-icon inline="true">north_east</mat-icon>
    </a>
</div>

<div class="talent-video"
    *ngIf="scope.config.enableTalentVideo !== false"
    appVideoEditContainer="home"
    [currentUrl]="scope.component.assets?.video"
    name="YouTube Video">
    <h2 class="talent-video__heading"
        appTextEditContainer="home"
        name="Talent Video Heading"
        [title]="'TALENT_VIDEO_HEADING'">{{scope.getText | transform:'TALENT_VIDEO_HEADING'}}</h2>
    <div class="talent-video__embed" *ngIf="scope.component.assets?.video">
        <iframe
            [src]="getSafeVideoUrl(scope.component.assets.video)"
            [title]="scope.getText | transform:'TALENT_VIDEO_HEADING'"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>
    </div>
</div>
</ng-container>
<ng-template #showNoAccessMsg>
    <div class="no-access-msg">
        <mat-icon>settings</mat-icon>
        <h1>{{scope.translations.NO_ACCESS_HOME_PAGE}}</h1>
    </div>
</ng-template>
